module.exports = __webpack_public_path__ + "static/media/layout-blue.6caf560c.svg";